import React from "react";
import './c14_floating_bar.scss';
import {PageLeftItem} from "../../model/page";
import {Col, Container, Row} from "react-bootstrap";
import {LAST_COMPONENT_ID} from "../../config/api_config";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {extraSmallLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";


export interface C14FloatingBarLeftItemData extends PageLeftItem {
    left_label: string;
    center_label: string;
    right_label: string;
    left_url?: string,
    center_url?: string;
}

/**
 * The left item shows a bar fixed at the bottom of the screen.
 * The editor can insert two links for the first and the second label,
 * while the latest label always scrolls to the last component in the page.
 */
class C14FloatingBarLeftItem extends TemplateComponent<C14FloatingBarLeftItemData> {

    componentRender(data: C14FloatingBarLeftItemData): React.ReactElement<any> {

        if(extraSmallLayout()) return <div />;

        return (
            <Container className="c14-floating-bar" fluid={true}>
                <Row>
                    <Col xs={5}>
                        <div className="left-col">
                            {
                                data.left_url ?
                                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                                    <a href={data.left_url} className="editor-html" {...insertHtml(data.left_label)} />
                                    :
                                    <p className="editor-html" {...insertHtml(data.left_label)} />
                            }
                        </div>
                    </Col>
                    <Col xs={5} className="center-col">
                        {
                            data.center_url ?
                                // eslint-disable-next-line jsx-a11y/anchor-has-content
                                <a href={data.center_url} className="editor-html" {...insertHtml(data.center_label)}/>
                                :
                                <p className="editor-html" {...insertHtml(data.center_label)}/>
                        }
                    </Col>
                    <Col xs={2} className="right-col">
                        <a className="editor-html" href={`#${LAST_COMPONENT_ID}`}>↓ <p {...insertHtml(data.right_label)} /> ↓</a>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default C14FloatingBarLeftItem;
